$(() => {
  let disable = false;

  $('[data-disable-on-submit]').on('click', function () {
    disable = true;
  });

  $('[data-disable-on-submit]')
    .parents('form')
    .on('submit', function () {
      if (disable) {
        $('[data-disable-on-submit]').prop('disabled', true);
      }
    });
});
